import React, { useEffect, useState } from "react";
import { useStores } from "../../store";
import { useObserver } from "mobx-react";
import { AiOutlineClose } from "react-icons/ai";
import { apiGet } from "../../api/api_methods";
import { toJS } from "mobx";
import Loader2 from "../reusble_components/loader2";

export default function Notification({ popUpInitialValue, handlePopup }) {
  const { PopupStore, UserStore } = useStores();

  const closeThisPopUP = () => {
    handlePopup();
  };

  useEffect(() => {
    UserStore.fetchNotifications().catch(console.error);
  }, []);

  const DateConverter = (date) => {
    date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let dt = date.getDate();
    if (dt < 10) {
      dt = "0" + dt;
    }
    if (month < 10) {
      month = "0" + month;
    }
    return dt + "/" + month + "/" + year;
  };

  return useObserver(() => (
    <>
      {popUpInitialValue ? (
        <div
          onClick={() => closeThisPopUP()}
          className="fixed inset-0 z-[500] bg-black/30 backdrop-blur-none"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
          >
            <div className="relative w-full max-w-2xl bg-white rounded-lg shadow-xl">
              <Loader2 loader={UserStore.loading} />

              {/* Header */}
              <div className="flex items-center justify-between p-4 border-b">
                <h1 className="text-xl font-semibold text-gray-800">
                  Notifications
                </h1>
                <button
                  onClick={closeThisPopUP}
                  className="p-1 text-gray-400 hover:text-gray-600 transition-colors"
                >
                  <AiOutlineClose size={20} />
                </button>
              </div>

              {/* Notifications List */}
              <div className="max-h-[60vh] overflow-y-auto">
                {UserStore?.notifications &&
                UserStore?.notifications?.data?.length > 0 ? (
                  <div className="divide-y">
                    {UserStore.notifications?.data?.map((item, index) => (
                      <div
                        key={index}
                        className="p-4 hover:bg-gray-50 transition-colors"
                      >
                        <div className="flex items-start gap-3">
                          <div className="h-2 w-2 mt-2 bg-purple-500 rounded-full self-start" />
                          <div className="flex-1">
                            <p className="text-gray-800 text-sm">
                              {item?.message}
                            </p>
                            <p className="text-xs text-gray-500 mt-1">
                              {DateConverter(item?.createdAt)}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="flex items-center justify-center h-40 text-gray-500">
                    No notifications available
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  ));
}
